'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConnectedAccountAddress = exports.getCC = exports.getBCC = exports.getToAddresses = exports.getFromAddress = exports.getFrom = exports.getSubject = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _getEmailMetadata = require('./getEmailMetadata');

var _emailMetadataKeypaths = require('../constants/emailMetadataKeypaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSubject = exports.getSubject = function getSubject(commonMessage) {
  return (0, _getIn2.default)(_emailMetadataKeypaths.SUBJECT, (0, _getEmailMetadata.getEmailMetadata)(commonMessage));
};

var getFrom = exports.getFrom = function getFrom(commonMessage) {
  return (0, _getIn2.default)(_emailMetadataKeypaths.FROM, (0, _getEmailMetadata.getEmailMetadata)(commonMessage));
};

var getFromAddress = exports.getFromAddress = function getFromAddress(commonMessage) {
  return (0, _getIn2.default)(_emailMetadataKeypaths.FROM_EMAIL, (0, _getEmailMetadata.getEmailMetadata)(commonMessage));
};

var getToAddresses = exports.getToAddresses = function getToAddresses(commonMessage) {
  return (0, _getIn2.default)(_emailMetadataKeypaths.TO, (0, _getEmailMetadata.getEmailMetadata)(commonMessage));
};

var getBCC = exports.getBCC = function getBCC(commonMessage) {
  return (0, _getIn2.default)(_emailMetadataKeypaths.BCC, (0, _getEmailMetadata.getEmailMetadata)(commonMessage));
};

var getCC = exports.getCC = function getCC(commonMessage) {
  return (0, _getIn2.default)(_emailMetadataKeypaths.CC, (0, _getEmailMetadata.getEmailMetadata)(commonMessage));
};

var getConnectedAccountAddress = exports.getConnectedAccountAddress = function getConnectedAccountAddress(commonMessage) {
  return (0, _getIn2.default)(_emailMetadataKeypaths.CONNECTED_ACCOUNT_ADDRESS, (0, _getEmailMetadata.getEmailMetadata)(commonMessage));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/common-message-format/operators/emailMetadataGetters.js
// module id = 697
// module chunks = 2 3